// AI Provider Configuration
// Uses Vercel proxy in production, direct API locally

// Local development key (only used on localhost)
const LOCAL_DEV_KEY = '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';

export const AI_PROVIDERS = {
  groq: {
    name: 'Groq',
    directEndpoint: 'https://api.groq.com/openai/v1/chat/completions',
    proxyEndpoint: '/api/chat',
    model: 'llama-3.1-8b-instant',
  }
};

export const getAIConfig = () => {
  // Check if user has their own API key stored
  const userKey = localStorage.getItem('lifemath-api-key');
  const provider = AI_PROVIDERS.groq;

  // If user has their own key, use direct Groq API
  if (userKey) {
    return {
      endpoint: provider.directEndpoint,
      model: provider.model,
      apiKey: userKey,
      isUsingDefaultKey: false,
      useProxy: false
    };
  }

  // Use hardcoded key for both local and production (private app)
  return {
    endpoint: provider.directEndpoint,
    model: provider.model,
    apiKey: LOCAL_DEV_KEY,
    isUsingDefaultKey: true,
    useProxy: false
  };
};

export const setUserAPIKey = (key) => {
  if (key && key.trim()) {
    localStorage.setItem('lifemath-api-key', key.trim());
  } else {
    localStorage.removeItem('lifemath-api-key');
  }
};

export const clearUserAPIKey = () => {
  localStorage.removeItem('lifemath-api-key');
};

// Helper to make AI requests - supports both proxy and direct modes
export const makeAIRequest = async (messages, options = {}) => {
  const config = getAIConfig();
  const { temperature = 0.7, max_tokens = 2000 } = options;

  // Build headers - only include Authorization for direct API calls
  const headers = {
    'Content-Type': 'application/json',
  };

  // If using direct API (user has their own key), add Authorization header
  if (!config.useProxy && config.apiKey) {
    headers['Authorization'] = `Bearer ${config.apiKey}`;
  }

  const response = await fetch(config.endpoint, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      model: config.model,
      messages,
      temperature,
      max_tokens,
    }),
  });
  return response;
};
